export default __webpack_public_path__ + "ui/assets/img/arrow-back-20-10.svg";